<template>
  <div class="file-synthesizeWrapper">
    <div class="file-inputFullWrapper">
      <div class="file-subTitle">Файл хуулах</div>
      <div v-if="!uploadLoading" class="file-inputWrapper">
        <FileUploadIcon :width="60" :height="60" />
        <div class="file-inputInfo">Боломжит файлын төрөл: doc, pdf, text</div>
        <!-- <div class="file-inputIns">Та уншуулах файлаа сонгож оруулна уу</div> -->
        <div class="file-input">
          <v-file-input
            id="fileInput"
            v-model="file"
            truncate-length="20"
            label="Файл сонгох"
            small-chips
            color="#787ff7"
            accept=".doc, .docx, .pdf, .txt"
            show-size
            outlined
            dense
            prepend-icon="mdi-file-upload-outline"
            hide-details
          ></v-file-input>
        </div>
        <v-btn @click="uploadFile" class="file-uploadBtn"
          ><div style="height: 16px; margin-right: 10px"><UploadIcon /></div>
          Ачаалах</v-btn
        >
      </div>
      <div v-else class="file-uploadWrapper">
        <div class="file-uploadTitle">
          {{
            percentCompleted == 100 ? "Амжилттай хуулагдлаа" : "Хуулж байна..."
          }}
        </div>
        <div class="file-progressValue">{{ percentCompleted }}%</div>
        <v-progress-linear
          class="file-progressLinear"
          v-model="percentCompleted"
          height="6"
          color="#777FF6"
          rounded
        >
        </v-progress-linear>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import FileUploadIcon from "../components/icons/FileUploadIcon";
import UploadIcon from "../components/icons/UploadIcon";
import { mapActions } from "vuex";
export default {
  name: "FileUpload",
  components: {
    FileUploadIcon,
    UploadIcon,
  },
  props: {
    selectedFile: File,
    folderId: Number,
    clientKey: String,
    addFileInfo: { type: Function },
    clearState: { type: Function },
  },
  data: () => ({
    uploadLoading: false,
    percentCompleted: 0,
  }),
  computed: {
    getCurrentRoute: function() {
      return this.$router.currentRoute.name;
    },
    getToken: function() {
      return this.$cookie.get("token");
    },
  },
  created() {
    this.file = this.selectedFile;
  },
  methods: {
    ...mapActions([
      "showWarningMessage",
      "showSuccessMessage",
      "showErrorMessage",
      "checkError",
    ]),
    uploadFile() {
      if (this.file != null) {
        const formData = new FormData();
        formData.append("upload", this.file);
        const headers = {
          token: this.getToken,
        };
        this.uploadLoading = true;
        axios
          .post(
            `${process.env.VUE_APP_BASE_URL}/v2/synthesize/${this.folderId}?voiceID=1&speed=1&type=file`,
            formData,
            {
              headers,
              onUploadProgress: function(progressEvent) {
                var percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                if (percent != 100) {
                  this.percentCompleted = percent;
                }
              }.bind(this),
            }
          )
          .then((response) => {
            this.percentCompleted = 100;
            if (response.status == 200) {
              this.showSuccessMessage({
                message: "Файл амжилттай хуулагдлаа",
                timeout: 3000,
              });

              this.addFileInfo(response.data.data.group_id, this.file.name);
            }
            this.file = null;

            this.uploadLoading = false;

            // this.addFileInfo(response.data.data);
          })
          .catch((error) => {
            this.uploadLoading = false;
            this.checkError(error);
          });
      } else {
        this.showWarningMessage({
          message: "Файл оруулна уу.",
          timeout: 3000,
        });
      }
    },
  },
};
</script>
<style scoped>
.file-synthesizeButton {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
}

.file-subTitle {
  font-size: 14px;
  font-weight: 700;
  color: #767676;
  margin-bottom: 8px;
}

.file-inputInfo {
  font-size: 14px;
  color: #767676;
  margin: 8px 0px;
}

.file-synthesizeWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-inputFullWrapper {
  width: 60%;
  display: flex;
  position: relative;
  flex-direction: column;
}

.file-inputWrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 8px;
}

.file-uploadWrapper {
  width: 100%;
  height: 211px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 16px;
}

.file-progressValue {
  display: flex;
  width: 100%;
  text-align: right;
  justify-content: flex-end;
  color: #98a7ad;
  font-weight: 500;
}

.file-uploadTitle {
  color: #231f20;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  margin-bottom: 30px;
}

.v-progress-linear {
  background-color: #e5e5e5 !important;
}

.file-input {
  width: 300px;
}

.file-inputIns {
  font-size: 14px;
  color: #767676;
  font-weight: 700;
  margin-bottom: 20px;
}

.file-uploadBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
  margin-top: 16px;
}
@media screen and (max-width: 930px) {
  .file-synthesizeWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .file-inputFullWrapper {
    width: 100%;
  }

  .file-settingsWrapper {
    width: 100%;
    margin: 0;
  }

  .file-toolsWrapper {
    height: auto;
  }
}

@media screen and (max-width: 599px) {
  .file-subTitle {
    display: flex;
    justify-content: center;
  }

  .file-input {
    width: 250px;
  }
}
</style>
